import { Component,ChangeDetectorRef } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { APPCONFIG } from '../../../config';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MdDialog,MdDialogRef } from '@angular/material';
import { IcbService } from '../../icb.service'
import { ErrorHandler } from '../../../shared/services/error-handler.service'
import { HttpService } from '../../../shared/services/http.service'
import { LayoutService } from '../../../layout/layout.service'
import { SessionHandler } from '../../../shared/services/session-handler.service';
import { CommonService } from '../../../shared/services/common.service';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { dialogComponent } from '../../../dialog/dialog.component';
import { termsDialogComponent } from '../../../dialog/dialog.component';
import {TranslateService} from 'ng2-translate';

@Component({
    selector: 'request-add',
    template: require('./confirm.component.html'),
    styles: [require('./confirm.component.scss')],
    providers: [HttpService, ErrorHandler,SessionHandler,IcbService]
})

export class t2tConfirmComponent {
    responseMessage:any;
    SoId:any;
    currentLang:any;
	constructor(private router: Router,private route: ActivatedRoute,private http:HttpService,private formBuilder: FormBuilder, private commonService : CommonService,
    private sessionHandler:SessionHandler,private dialog: MdDialog,private translate: TranslateService,
    private ref:ChangeDetectorRef) {
        this.currentLang = translate.currentLang;
        let data = this.commonService.getData();
        if(data && data['soId']) {
            this.SoId = data['soId'];
        } else {
            this.router.navigateByUrl('/app/icb/trade/data');
        }
        this.responseMessage = 'Successfully Submitted';

	
        this.commonService.clearIcbImageData();
    }

    public newRequest() {
        this.commonService.setData(null);
        this.sessionHandler.saveItem("t2tCount", '1');
        this.router.navigateByUrl('/app/icb/trade/data');

    }

}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/icb/t2t/confirm/confirm.component.ts